{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Mesaj nou",
  "chat.scrollToBottom": "Derulează până jos",
  "messagefeedback.thumbDown": "Răspuns greșit",
  "messagefeedback.thumbUp": "Răspuns bun",
  "promptfield.aiDisclaimer": "Răspunsurile sunt generate folosind AI și pot fi inexacte. Verifică înainte de utilizare.",
  "promptfield.aiUserGuidlines": "Ghiduri pentru utilizatori AI",
  "promptfield.attachments": "Atașamentele",
  "promptfield.insertButton": "Adaugă",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Sunteți gata să începeți? Puneți o întrebare, împărtășiți o idee sau adaugați o sarcină.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Stop",
  "promptfield.submitButton": "Trimite",
  "promptfield.uploading": "Încărcare",
  "responsestatus.loading": "Se încarcă",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Începe înregistrarea",
  "voicebutton.stopListening": "Opriți înregistrarea",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
